<template>
    <div data-test="category-related-detail-table" class="category-related-detail-table">
        <!-- Table Container Card -->
        <div no-body class="mb-0 px-1">
            <div
                tag="h1"
                class="d-flex justify-content-end align-items-center mt-.5"
            >
                <div class="d-flex align-items-center justify-content-end">
                    <p class="category-title text-primary h3">
                        {{ title }}
                    </p>
                </div>
            </div>

            <div>
                <div class="my-2 filter-and-search">
                    <!-- Table Top -->
                    <b-row>
                        <!-- Per Page -->
                        <b-col
                            cols="12"
                            md="6"
                            class="
                                d-flex
                                align-items-center
                                justify-content-start
                                mb-1 mb-md-0
                                show-entries-select-box
                            "
                        >
                            <label class="show">Show</label>
                            <v-select
                                v-model="perPage"
                                :dir="
                                    $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="perPageOptions"
                                :clearable="false"
                                class="per-page-selector d-inline-block mx-50"
                            />
                            <label>entries</label>
                        </b-col>

                        <!-- FILTERS -->
                        <b-col cols="12" md="6">
                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-end
                                "
                            >
                                <b-form-input
                                    v-model="searchQuery"
                                    class="d-inline-block mr-1 search-input"
                                    placeholder="Search..."
                                    data-test="search"
                                    style="width: 50%"
                                />

                                <b-button
                                    variant="primary"
                                    class="btn-sm scanner"
                                    data-test="add-a-new-mas-list"
                                    :disabled="checkedList.length <= 0"
                                    style="height: 35px"
                                    @click="systemScreening()"
                                >
                                    <span class="text-nowrap d-flex align-items-center justify-content-center">
                                        Scan
                                        <normal-loader v-if="isScanning" class="ml-.5" />
                                        <vector
                                            v-else
                                            data-name="document-screening-icon"
                                            data-style="margin-left: 8px;"
                                        />
                                    </span>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <b-table
                    ref="refComplianceTable"
                    class="position-relative"
                    style="font-size: 13.5px"
                    :items="currentDetails"
                    :fields="tableColumns"
                    :current-page="currentPage"
                    :per-page="perPage"
                    responsive
                    primary-key="id"
                    busy.sync="isBusy"
                    :filter="searchQuery"
                >
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>

                    <template #head(selectAll)>
                        <b-form-checkbox v-model="shouldSelectAll" class="select-all" @change="checkAll($event)"></b-form-checkbox>
                    </template>

                    <template #cell(selectAll)="data">
                        <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group
                                id="selected-documents"
                                v-model="checkedList"
                                :checked="!! data.item.scannedOn"
                                :aria-describedby="ariaDescribedby"
                                name="checked_data"
                            >
                                <b-form-checkbox :value="data.item"></b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </template>

                    <template #cell(functions)="data">
                        <span v-if="Array.isArray(data.item.functions)">
                            <span
                                v-for="(item, i) in data.item.functions"
                                :key="item"
                            >
                                {{ item }}
                                <span
                                    v-if="data.item.functions.length > i + 1"
                                >,
                                </span>
                            </span>
                        </span>
                        <span v-else>
                            {{ data.item.functions }}
                        </span>
                    </template>

                    <template #cell(country)="data">
                        <span v-if="typeof data.item.country === 'object'">
                            {{ data.item.country.COUNTRY0 }}
                        </span>
                        <span v-else>
                            {{ data.item.country }}
                        </span>
                    </template>

                    <!-- Column: Actions -->
                    <template #cell(actions)="data">
                        <div class="cursor-pointer">
                            <!-- update vertical menu -->
                            <div>
                                <b-dropdown size="sm" menu-class="" dropright variant="link" toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <feather-icon icon="MoreVerticalIcon"/>
                                    </template>

                                    <!-- view -->
                                    <b-dropdown-item
                                        :data-test="`view-${data.item.id}`"
                                        @click="view(data.item)"
                                    >
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="EyeIcon" />
                                            <span style="padding-top: .1em; padding-left: .5em">View</span>
                                        </div>
                                    </b-dropdown-item>

                                    <!--  checked -->
                                    <b-dropdown-item
                                        v-if="showCheckedMenusOption(data.item)"
                                        :data-test="`check-${data.item.id}`"
                                        @click="checked(data.item)"
                                    >
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="CheckIcon" />
                                            <span style="padding-top: .1em; padding-left: .5em">Mark As Checked</span>
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                            <!-- end updating vertical menu -->

                            <!-- <div v-else class="d-flex align-items-center justify-content-end"
                                :data-test="`view-${data.item.id}`"
                                @click="view(data.item)"
                            >
                                <feather-icon icon="EyeIcon" />
                                <span
                                    style="
                                        margin-top: -1px;
                                        padding-left: 4px;
                                    "
                                    >View</span
                                >
                            </div> -->
                            
                        </div>
                    </template>
                </b-table>

                <loader
                    v-if="isLoading"
                    data-type="Table"
                    class="custom-loading"
                />

                <div class="mx-2 mb-2">
                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            class="
                                d-flex
                                align-items-center
                                justify-content-center justify-content-sm-start
                            "
                        >
                            <span class="text-muted"
                                >Showing {{ dataMeta.from }} to
                                {{ dataMeta.to }} of
                                {{ dataMeta.of }} entries</span
                            >
                        </b-col>
                        <!-- Pagination -->
                        <b-col
                            cols="12"
                            sm="6"
                            class="
                                d-flex
                                align-items-center
                                justify-content-center justify-content-sm-end
                            "
                        >
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalCompliance"
                                :per-page="perPage"
                                first-number
                                last-number
                                class="mb-0 mt-1 mt-sm-0"
                                prev-class="prev-item"
                                next-class="next-item"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BTable,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BPagination,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import useCategoryRelatedDetails from "./useCategoryRelatedDetails";

export default {
    components: {
        BRow,
        BCol,
        BTable,
        vSelect,
        BButton,
        BDropdown,
        BFormInput,
        BPagination,
        BDropdownItem,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormGroup
    },

    props: {
        currentDetails: {
            type: Array,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        currentActiveTab: {
            type: String,
            required: true,
        },

        isLoading: {
            type: Boolean,
            required: true,
        },

        isScanning: {
            type: Boolean,
            required: true
        }
    },

    setup(props) {
        const {
            sortBy,
            isBusy,
            perPage,
            dataMeta,
            currentPage,
            searchQuery,
            tableColumns,
            isSortDirDesc,
            perPageOptions,
            totalCompliance,
            refComplianceTable,
            dynamicTableColumn,
            resolveMasListStatusVariant,
        } = useCategoryRelatedDetails(props.currentActiveTab);

        return {
            sortBy,
            perPage,
            dataMeta,
            searchQuery,
            currentPage,
            tableColumns,
            isSortDirDesc,
            perPageOptions,
            refComplianceTable,
            resolveMasListStatusVariant,
            dynamicTableColumn,

            totalCompliance,

            // UI
            isBusy,
        };
    },

    data() {
        return {
            checkedList: [],
            shouldSelectAll: false
        };
    },

    watch: {
        currentActiveTab(activeTab) {
            this.dynamicTableColumn(activeTab);
        },
    },

    created() {
        this.dynamicTableColumn(this.currentActiveTab);
    },

    methods: {
        showCheckedMenusOption(data) {
            const result = data.result?.toLowerCase()?.trim();
            return ! (result === 'not found' || result === 'checked');
        },

        checkAll(isChecked) {
            this.checkedList = [];
            if (isChecked) {
                this.currentDetails.forEach(record => {
                    if (! record.scannedOn)
                        this.checkedList.push(record);
                });
            }
        },

        view(data) {
            this.$emit("view", data);
        },

        checked(data) {
            this.$emit("checked", data);
        },

        systemScreening() {
            if (this.checkedList.length) {
                this.$emit("systemScreening", this.checkedList);
            }

            // if (this.filter === "uncheck" && this.currentDetails.length >= 1) {
            //     this.$emit("systemScreening");
            // }
        },
    },
};
</script>

<style lang="scss" scoped>
.category-title {
    position: absolute;
    white-space: nowrap;
    top: 28px;
}

#selected-documents {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

#selected-documents .custom-control.custom-checkbox {
  margin-top: 0.5em;
  margin-bottom: 1.8px;
}
</style>

<style>
.scanner .preloader {
    left: 50% !important;
}
</style>